import React, { useEffect, useState } from "react";
import LastNews from "./lastnews";
import { Link } from "react-router-dom";
import Axios from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';

const Regulation = () => {
  const [RegulationData, setRegulationData] = useState([]);
  const [RegulationLoading, setRegulationLoading] = useState(true);
  const [errorRegulation, setRegulationError] = useState(null);

  useEffect(() => {
    const fetchRegulationData = async () => {
      try {
        const response = await Axios.get(`${URL}api/Regulation/getregulationsDataLists`);
        console.log('Response:', response.data);
        setRegulationData(response.data);
        setRegulationLoading(false);
      } catch (error) {
        console.log('Error:', error);
        setRegulationError(error);
        setRegulationLoading(false);
      }
    };

    fetchRegulationData();
  }, []);

  if (RegulationLoading) {
    return <div>Loading...</div>;
  }

  if (errorRegulation) {
    return <div>Error: {errorRegulation.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="regulation" className="a-breadcrumbs">ข้อบังคับสหกรณ์</a>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-md-offset-1">
              <h2 className="title-section mb-0 mt-0 text-center">
                <span>ข้อบังคับสหกรณ์</span>
              </h2>
              <br/>
              <div className="divider mb-20 mt-25 gray" />
            </div>
          </div>

          <div className="row mt-40">
            <div className="col-md-8 col-md-offset-2">
              {RegulationData && RegulationData.length > 0 ? (
                <div className="list-group">
                  {RegulationData.map((item, index) => (
                    <a 
                      key={item.id || index}
                      
                      href={`${IMGPATHS}FileUpload/Regulation/${item.attachfile}`}
                      className="list-group-item list-group-item-action"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        padding: '15px 20px',
                        marginBottom: '10px',
                        borderRadius: '5px',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <i className="fa fa-file-pdf-o" style={{ fontSize: '24px', color: '#dc3545', marginRight: '15px' }}></i>
                          <h5 className="mb-0" style={{ color: '#333', fontWeight: '500' }}>
                            {item.topic}
                          </h5>
                        </div>
                        <i className="fa fa-download" style={{ color: '#28a6ec' }}></i>
                      </div>
                    </a>
                  ))}
                </div>
              ) : (
                <div className="col-12 text-center">
                  <div className="alert alert-info" role="alert">
                    <i className="fa fa-info-circle" style={{ marginRight: '10px' }}></i>
                    ไม่พบข้อมูลข้อบังคับสหกรณ์
                  </div>
                </div>
              )}
            </div>

            <LastNews />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Regulation;